Apt.fn.make('locator', {
	/**
	 * Initialize module
	 *
	 * @param {$} el
	 * @param {Object} [options]
	 * @returns {Object}
	 */
	init(el, options) {
		const scope = this;

		scope.$private.setup(el, options);

		return scope;
	},

	/**
	 * Collapse results
	 */
	collapse() {
		this.$private.collapse();
	},

	/**
	 * Highlight the input element
	 */
	highlight() {
		LS.validate.highlight(this.$private.$input, true);
	},

	/**
	 * Blur the locator input
	 */
	blur() {
		this.$private.$input.blur();
	},

	/**
	 * Get selected value
	 *
	 * @returns {Object}
	 */
	val() {
		return this.$private.app.$get('value');
	},

	/**
	 * Get input text
	 *
	 * @returns {String}
	 */
	text() {
		return this.$private.$input[0].value;
	},

	/**
	 * Set selected value
	 *
	 * @param {Boolean|Object} [value]
	 */
	set(value) {
		const scope = this;
		const priv = scope.$private;

		if (! priv.app) {
			return;
		}

		if (value === true) {
			priv.setDefault();

			return;
		}

		if (value && value.name) {
			priv.val = priv.default = LS.location.heading(value, true);

			priv.app.$set('value', value);

			priv.$input.val(priv.val);

			return;
		}

		scope.clear(true);
	},

	/**
	 * Clear input values
	 *
	 * @param {Boolean} [empty=false]
	 */
	clear(empty) {
		const priv = this.$private;

		priv.default = priv.val = null;

		priv.app.$drop('value');

		if (empty) {
			priv.$input.val('');
		}
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		const priv = this.$private;

		priv.collapse();

		LS.util.reset(priv.uid, priv, 'app', true);
	}
}, {
	/**
	 * Generate target elements and create application
	 *
	 * @param {$} el
	 * @param {Object} [options]
	 */
	setup(el, options) {
		const scope = this;
		const conf = Object.assign({
			default: false
		}, options);

		scope.uid = LS.util.uid();

		conf.key = conf.id ?
			'id' : (conf.key || 'slug');

		scope.conf = conf;

		scope.$target = $(el);
		scope.$input = $('input', scope.$target);
		scope.$results = $('<div class="locator__content"/>');

		const input = scope.$input[0];

		scope.$target.append(scope.$results);

		scope.app = $.app.make(scope.uid, {
			target: scope.$results,
			view: 'locator.results',
			model: {
				id: conf.id,
				key: conf.key,
				fetch: conf.fetch &&
					typeof navigator.geolocation !== 'undefined',
				name: input.name || 'location',
				uid: scope.uid
			}
		});

		scope.$input.removeAttr('name');

		input.autocomplete = 'off';
		input.role = 'combobox';
		input.spellcheck = 'false';

		input.setAttribute('aria-autocomplete', 'list');
		input.setAttribute('aria-controls', scope.uid);
		input.setAttribute('aria-expanded', 'false');

		const value = conf.value || scope.$input.data('value');

		if (value) {
			scope.$public.set(value);

			if (conf.fetch) {
				scope.query(false);
			}
		} else if (conf.default && ! window.crawler) {
			scope.setDefault();
		}

		scope.bindEvents();
	},

	/**
	 * Set the default location based on user data
	 */
	setDefault() {
		const scope = this;

		let loc = LS.store.get('user_search');

		if (loc) {
			scope.setLocation(loc);
			scope.query(false);

			return;
		}

		$.observe('user', data => {
			loc = (data || {}).location;

			if (loc) {
				if ((loc.country || 'US') === 'US') {
					scope.setLocation(loc);
				}

				$.unobserve('*', {
					namespace: scope.uid
				});
			}

			scope.query(false);
		}, {
			init: true,
			namespace: scope.uid,
			recursive: true
		});
	},

	/**
	 * Set the default location value
	 *
	 * @param {Object} loc
	 */
	setLocation(loc) {
		const scope = this;
		const $input = scope.$input;

		if (! $input.val() && ! scope.default) {
			let value = loc.name;

			if (loc.locality) {
				value = loc.locality + ', ' + loc.territory;
			}

			if (value) {
				scope.val = scope.default = value;

				$input.val(value);

				scope.app.$set('value', loc);
			}
		}
	},

	/**
	 * Bind result, input, and wrapper events
	 */
	bindEvents() {
		const scope = this;
		const $input = scope.$input;

		let cancel;
		let down;
		let blur;
		let id;
		let init;
		let value;

		// Attach click events to result entries
		$.events.on('$locatorEntry', {
			click: (e, el) => {
				down = false;

				scope.select(el);
			},
			mousedown: () => {
				down = true;

				$(document).on('mouseup', e => {
					if (! scope.$target[0].contains(e.target)) {
						down = false;

						scope.collapse();
					}
				}, {
					namespace: scope.uid,
					once: true
				});
			}
		}, {
			delegate: scope.$results,
			namespace: scope.uid
		});

		// Bind primary result events
		$input.on({
			mousedown: () => {
				if (! scope.active) {
					$input.trigger('focus');
				}
			},
			focus: (e, el) => {
				if (blur) {
					blur = false;

					return;
				}

				id = el.id || '';
				value = el.value;

				// Suppress autocompletion
				el.id = 'new-search';
				el.autocomplete = 'new-password';

				el.setAttribute('aria-expanded', 'true');

				scope.show();

				if (scope.$public.val() && scope.conf.type !== 'address') {
					el.value = '';
				}

				if (! init) {
					scope.process(null, scope.default ? '' : el.value);
				}

				init = true;

				$.exec(scope.conf.focused);
			},
			blur: (e, el) => {
				if (e.target === document.activeElement) {
					return;
				}

				el.id = id;
				el.autocomplete = 'off';

				el.setAttribute('aria-expanded', 'false');

				if (! down) {
					if (! cancel) {
						scope.blur(el.value);
					}

					setTimeout(() => {
						scope.collapse();
					}, 100);
				}

				cancel = false;
			},
			keydown: (e, el) => {
				const key = e.keyCode || 13;

				cancel = false;

				if (key === 38 || key === 40) { // Arrow up or down
					e.preventDefault();
				} else if (key === 13) { // Enter
					cancel = true;

					if (scope.active) {
						e.preventDefault();
					}

					if (scope.pending) {
						scope.wait = true;
					} else if (scope.app.$get('results')) {
						scope.action();
					} else {
						cancel = false;
					}

					el.blur();
				} else if (key === 27) { // Escape
					scope.val = null;

					el.blur();
				} else if (key === 9) { // Tab
					scope.abort();

					if (scope.$active) {
						cancel = true;

						scope.set(scope.$active[0].dataset.index);
					}

					el.blur();
				} else if (key === 8) { // Backspace
					if (! el.value) {
						scope.$public.clear();
					}
				} else if ((e.ctrlKey || e.metaKey) && key !== 86) { // Control
					cancel = true;
				}
			},
			keyup: (e, el) => {
				if (! cancel) {
					scope.process(e.keyCode, el.value);
				}

				e.preventDefault();
				e.stopPropagation();
			}
		}, {
			namespace: scope.uid
		});

		$(window).on('blur', () => {
			if (scope.visible) {
				blur = true;

				scope.blur($input.val());

				scope.collapse();
			}
		}, {
			namespace: scope.uid
		});
	},

	/**
	 * Blur input
	 *
	 * @param {String} val
	 */
	blur(val) {
		const scope = this;

		if (scope.conf.type === 'address') {
			if (! val) {
				scope.$public.clear(true);
			}
		} else {
			if (val && scope.app.$get('results')) {
				scope.set(0);
			} else if (! val && scope.val) {
				scope.$input.val(scope.val);
			} else if (! val || val !== scope.val) {
				scope.$public.clear(true);
			}
		}
	},

	/**
	 * Collapse the visible result list
	 */
	collapse() {
		const scope = this;

		scope.active = scope.$active = scope.$entries = null;

		scope.abort();

		if (scope.visible) {
			$$('wrapper').off('click.' + scope.uid);

			if (scope.conf.collapse) {
				scope.conf.collapse(scope.$input.val());
			}
		}

		scope.hide();
	},

	/**
	 * Process the keyup event for evaluation
	 *
	 * @param {Number} key
	 * @param {String} val
	 */
	process(key, val) {
		const scope = this;

		scope.active = true;

		if (scope.$active) {
			scope.$active[0].classList.remove('-is-active');
			scope.$active[0].removeAttribute('aria-selected');
		}

		if (key === 38 || key === 40) { // Arrow up or down
			if (scope.$active) {
				let $active = scope.$active;

				$active = key === 40 ?
					$active.next() :
					$active.prev();

				if ($active.length) {
					scope.$active = $active;
				}
			} else if (
				key === 40 &&
				scope.app.$get('results')
			) {
				scope.$active = scope.$entries.first();
			} else {
				scope.$active = null;
			}

			if (scope.$active) {
				scope.$active[0].classList.add('-is-active');
				scope.$active[0].setAttribute('aria-selected', 'true');
			}
		} else if (val.length > 1 || ! val) {
			if (key !== 32) {
				scope.abort();
			}

			const fn = () => {
				scope.cancel();
				scope.query(val);
			};

			if (! scope.pending) {
				scope.state(true);
			}

			if (! val) {
				fn();

				return;
			}

			scope.pending = setTimeout(fn, 150);
		}
	},

	/**
	 * Cancel pending requests
	 */
	cancel() {
		const scope = this;

		clearTimeout(scope.pending);

		scope.pending = null;
	},

	/**
	 * Flush pending operations
	 */
	abort() {
		const scope = this;

		$.fetch.abort(scope.uid);

		scope.cancel();
		scope.state();
	},

	/**
	 * Query API for updated locator suggestions
	 *
	 * @param {String} value
	 */
	query(value) {
		const scope = this;
		const type = scope.conf.type || 'all';

		scope.$active = null;

		if (value === false) {
			const nearby = scope.$get(type, []);

			if (nearby === true) {
				return;
			}

			if (nearby.length) {
				scope.populate(value, nearby);

				return;
			}

			scope.$set(type, true);
		} else {
			value = value.trim();

			if (value === scope.previous) {
				scope.show();

				return;
			}
		}

		scope.previous = value;

		const loc = scope.$public.val() || LS.user.location();
		const data = {
			limit: scope.getLimit()
		};

		if (value) {
			data.value = value;
		}

		if (loc) {
			if (loc.slug) {
				data.center = loc.slug;
			} else if (loc.center) {
				data.center = loc.center;
			} else if (loc.latitude) {
				data.center = [
					loc.longitude,
					loc.latitude
				];
			}
		}

		const options = {
			namespace: scope.uid,
			data: data,
			success: data => {
				if (value && ! data.features.length && value.includes(',')) {
					scope.queryAddress(type, value, data);

					return;
				}

				scope.transform(type, value, data.features);

				if (! value) {
					scope.stash = data.features;
				}
			}
		};

		let center = scope.conf.center;

		if (center) {
			center = LS.util.val(center, data);

			if (center) {
				data.center = center;
			}
		}

		if (scope.conf.type === 'address' || (
			value && scope.conf.address && (
				value.match(/^\d{1,4} *[a-z]/i) ||
				value.match(/ (ave(nue)?|dr(ive)?|r(oa)?d|st(reet)?)\.?( |$)/i) ||
				value.match(/(highway|hwy)\.? /i)
			)
		)) {
			scope.queryAddress(type, value, data);

			return;
		}

		if (scope.conf.type) {
			options.data.type = $.toArray(scope.conf.type);
		}

		if (! value && scope.stash) {
			scope.populate(value, scope.stash);

			return;
		}

		LS.api.get('locations/autocomplete', options);
	},

	/**
	 * Query API for address suggestions
	 *
	 * @param {String} key
	 * @param {String} value
	 * @param {Object} data
	 */
	queryAddress(key, value, data) {
		const scope = this;
		const query = {
			access_token: $.get('global.mapboxKey'), // eslint-disable-line
			country: 'US',
			limit: data.limit,
			types: 'address'
		};

		if (! value) {
			scope.hide();

			return;
		}

		if (Array.isArray(data.center)) {
			query.proximity = data.center.join(',');
		} else {
			const loc = LS.user.location();

			if (loc) {
				query.proximity = loc.longitude + ',' + loc.latitude;
			}
		}

		$.fetch.request({
			root: 'https://api.mapbox.com/geocoding/v5/mapbox.places/',
			url: value + '.json',
			json: true,
			namespace: scope.uid,
			data: query,
			success: data => {
				scope.transform(key, value, data.features.map(feature => {
					const name = (feature.address ? feature.address + ' ' : '') + feature.text;

					return {
						name: name,
						type: 'address',
						slug: scope.conf.key === 'name' ?
							name : feature.center.join('+'),
						center: feature.center,
						parent: {
							name: feature.place_name.split(',')
								.splice(1, 2)
								.join(',')
						},
						feature: feature
					};
				}));
			}
		});
	},

	/**
	 * Get result limit
	 *
	 * @returns {Number}
	 */
	getLimit() {
		return this.conf.limit || 5;
	},

	/**
	 * Transform query results
	 *
	 * @param {String} key
	 * @param {String} value
	 * @param {Array} features
	 */
	transform(key, value, features) {
		const scope = this;

		let match;

		if (! scope.app) {
			return;
		}

		if (value) {
			const keywords = value.split(/[ ,]/)
				.map(keyword => keyword.trim())
				.filter(Boolean);

			if (keywords.length > 1) {
				keywords.unshift(value.replace(/ /g, '[ ,]+'));
			}

			try {
				match = new RegExp('(' + keywords.join('|') + ')(\\b| ?(?!([^<]+)?<))', 'gi');
			} catch (e) {
				//
			}
		}

		features.forEach(el => {
			el.name += (el.label ? ' ' + el.label : '') +
				(el.suffix ? ', ' + el.suffix : '');

			el.heading = match ?
				el.name.replace(match, '<b>$&</b>')
					.replace(/<\/b> +<b>/g, ' ') :
				el.name;

			if (el.parent) {
				el.parent.heading = LS.location.heading(el.parent, true);
			}
		});

		scope.populate(value, features);

		if (! value) {
			scope.$set(key, features);
		}
	},

	/**
	 * Render locator options
	 *
	 * @param {String} value
	 * @param {Array} results
	 */
	populate(value, results) {
		const scope = this;

		scope.state();

		if (! scope.app) {
			return;
		}

		if (results.length) {
			scope.app.$merge({
				message: false,
				results: results.slice(0, scope.getLimit())
			});

			if (scope.active) {
				scope.show();

				$.exec(scope.conf.load);
			}
		} else if (value) {
			scope.visible = true;

			scope.$entries = null;

			scope.app.$merge({
				message: scope.active,
				results: null
			});
		}

		if (scope.wait) {
			scope.$input.trigger('keydown');

			delete scope.wait;
		}
	},

	/**
	 * Set update state
	 *
	 * @param {Boolean} [update=false]
	 */
	state(update) {
		const scope = this;

		if (update) {
			if (! scope.updating) {
				scope.updating = true;

				scope.$results[0].classList.add('-is-updating');
			}

			return;
		}

		scope.updating = false;

		scope.$results[0].classList.remove('-is-updating');
	},

	/**
	 * Display results
	 */
	show() {
		const scope = this;

		scope.$entries = $$('locatorEntry', scope.$results);

		if (! scope.visible) {
			scope.visible = true;

			$.exec(scope.conf.opened);

			scope.$target[0].classList.add('-is-active');
			scope.$target[0].setAttribute('aria-selected', 'true');
		}
	},

	/**
	 * Hide results
	 */
	hide() {
		const scope = this;

		if (scope.visible) {
			scope.visible = false;

			$.exec(scope.conf.closed);

			scope.$target[0].classList.remove('-is-active');
			scope.$target[0].removeAttribute('aria-selected');
		}
	},

	/**
	 * Process available context for action
	 */
	action() {
		const scope = this;
		const $entries = scope.$entries;

		if (scope.$active) {
			scope.select(scope.$active[0]);
		} else if ($entries && $entries.length) {
			scope.select($entries[0]);
		} else {
			scope.collapse();
		}
	},

	/**
	 * Process locator result selection
	 *
	 * @param {$} el
	 */
	select(el) {
		const scope = this;
		const index = el.dataset.index;

		if (! /\d/.test(index)) {
			if (index === 'fetch') {
				LS.common.transition();

				navigator.geolocation.getCurrentPosition(pos => {
					scope.set({
						type: 'address',
						slug: [
							pos.coords.longitude,
							pos.coords.latitude
						].join('+')
					}, true);

					LS.common.transition(true);
				}, e => {
					LS.common.transition(true);

					LS.util.warn(e.message);
				}, {
					enableHighAccuracy: true,
					timeout: 5000,
					maximumAge: 300000
				});
			}

			return;
		}

		scope.set(index, true);
	},

	/**
	 * Set location
	 *
	 * @param {Number|Object} value
	 * @param {Boolean} [trigger=false]
	 */
	set(value, trigger) {
		const scope = this;

		if (! isNaN(value)) {
			value = scope.app.$get('results.' + value);
		}

		scope.default = null;

		scope.app.$set('value', value);

		if (value) {
			scope.val = value.name;

			scope.$input.val(scope.val);
		}

		scope.collapse();

		if (value && trigger && scope.conf.changed) {
			scope.conf.changed(value);

			if (value.type !== 'address') {
				LS.store.set('user_search', value);
			}
		}
	}
});